import { I18nt } from 'utils';
import { paths } from 'config';
import Card from 'components/Card';
import styles from './Home.module.less';
import { Link } from 'react-router-dom';
import { LangText, PathType } from 'utils/interfaces';
import {
	MedicineBoxFilled,
	CalendarFilled,
	ContainerFilled,
} from '@ant-design/icons';

interface CardContent {
	title: LangText;
	icon: JSX.Element;
	content: LangText;
	path: PathType;
}

const cards: CardContent[] = [
	{
		title: 'citas_medicas',
		icon: <CalendarFilled />,
		content: 'agendar_citas_ahora',
		path: 'citas_medicas',
	},
	{
		title: 'reserva_tu_medicamento',
		icon: <MedicineBoxFilled />,
		content: 'consulta_si_tu_receta',
		path: 'consultar_medicamentos',
	},
	{
		title: 'examenes_de_laboratorio',
		icon: <ContainerFilled />,
		content: 'consulta_si_tus_resultados',
		path: 'examenes_laboratorio',
	},
];

function NavigationCards() {
	const cardHeader = (Icon: JSX.Element, title: LangText) => (
		<div className={styles.cardHeader}>
			<span>{Icon}</span>
			<h4>{I18nt(title)}</h4>
		</div>
	);

	return (
		<div className={styles.cardsContainer}>
			{cards.map(({ title, icon, content, path }) => (
				<Link className={styles.cardLink} key={path} to={paths[path]}>
					<Card header={cardHeader(icon, title)}>
						<div className={styles.cardContent}>{I18nt(content)}</div>
					</Card>
				</Link>
			))}
		</div>
	);
}

export default NavigationCards;
